<template>
   <button 
    class="flex justify-between q-px-md" 
    :class="{'blue': color == 'blue', 'white': color == 'white'}"
  >
    <span> {{ btnName }} </span>
    <span>
      <q-icon name="chevron_right"/>
    </span>
  </button>  
</template>

<script>
export default {
  name: 'NextButton',
  data () {
    return {

    }
  },
  props: {
    btnName: String,
    color: String
  }
}
</script>
<style scoped>
  .white {
    background: white!important;
    border: white!important;
    color: black!important;
  }
  .blue {
    background: rgb(48,118,255)!important;
    border: rgb(48,118,255)!important;
  }
  button {
    background: black;
    border: black;
    color: white;
    font-weight: 600;
    width: 240px;
    height: 50px;
    border-radius: 10px;
  }

</style>

